"use strict";

exports.__esModule = true;
exports.raiseCallback = raiseCallback;
var _YoLog = require("./YoLog");
/*
 * COPYRIGHT 2022 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */

//
// raiseCallback helper - safely calls a callback and handles any exception that may be encountered.
//
// Arguments:
//   owner: the owner of the function.  Without it, calls to 'this' will fail.  It is expected to be a valid object
//   but can be null if it is an anonymous function
//
//   func: the function name (without parentheses and arguments).
//
//   args: any argument that the function requires.  Can be null, undefined or left out completely
//
// Returns:
//   the result of the function call
//
// Example usages:
//   raiseCallback(observer, observer.callbackFunction, arg1, arg2, arg3);
//   raiseCallback(observer, observer.callbackFunction);
//   let result = raiseCallback(observer, observer.callbackFunction, arg1, arg2);
//
function raiseCallback(owner, func) {
  // Bind the function to its owner as it no longer has a context and calls to 'this' would fail.
  if (owner) {
    func = func.bind(owner);
  }
  var ret = null;
  try {
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }
    ret = func.apply(void 0, args);
  } catch (e) {
    var f = func.toString();
    var reg = /function ([^\(]*)/;
    var name = reg.exec(f);
    // The regex is not expected to fail but let's not take chances
    if (name && name.length > 0) {
      _YoLog.YoLog.e("Exception thrown from callback function " + name[1] + ": " + e);
    } else {
      _YoLog.YoLog.e("Exception thrown from callback function.");
    }
  }
  return ret;
}